<style>
    .category-item::after {
        content: ",";
        position: relative;
    }
    .category-item-wrapper:last-of-type .category-item::after {
        content: "" !important;
    }
</style>
<div class="text-gray-700" id="kategorien">
    {{ "categories.ourCategories" | translate }}
</div>
<div
    class="lg:flex flex-wrap w-full md:w-2/3 lg:w-4/5 ~gap-x-2/4"
    #categoryContainer
>
    @for (category of categories(); track $index; let i = $index) {
        <div class="opacity-0 -translate-x-28 category-item-wrapper">
            <a
                class="block after:~-left-2/4 relative text-left leading-tight lg:leading-snug cursor-pointer ~text-[3rem]/[5rem] category-item"
                [ngClass]="[
                    selectedCategory().name === category.name &&
                    domHandler.isDesktop
                        ? 'text-black'
                        : 'text-gray-500',
                ]"
                (mouseover)="selectedCategory.set(category)"
                [routerLink]="[
                    '/',
                    languageService.getLanguageCode,
                    'hof',
                    'shop',
                ]"
                [queryParams]="{ category: category.slug }"
            >
                {{ category.name }}
            </a>
        </div>
    }
</div>
<div class="hidden lg:flex gap-4 size-full" #productContainer>
    @for (
        product of selectedCategory().products.slice(0, 4);
        track product.documentId
    ) {
        <a
            class="group relative mx-3 mt-3 w-1/4 min-w-sm h-full max-h-[30vh] overflow-visible product-image"
            routerLink="/{{ languageService.getLanguageCode }}/hof/produkt/{{
                product.slug
            }}"
            (click)="
                umami.track('product-click', {
                    product: product.name,
                })
            "
        >
            @if (product.images && product.images!.length > 0) {
                <img
                    class="peer top-0 right-0 relative bg-white size-full object-cover"
                    [src]="domHandler.getLargestImageAsWebp(product.images![0])"
                    [srcset]="
                        domHandler.generateSrcsetAsWebp(product.images![0])
                    "
                    alt="product image"
                    loading="lazy"
                />
                @if (product.images!.length > 1) {
                    <img
                        class="peer top-0 right-0 absolute bg-white opacity-0 lg:hover:opacity-100 lg:peer-hover:opacity-100 size-full object-cover transition-opacity duration-300"
                        [src]="
                            domHandler.getLargestImageAsWebp(product.images![1])
                        "
                        [srcset]="
                            domHandler.generateSrcsetAsWebp(product.images![1])
                        "
                        loading="lazy"
                        alt="product image"
                    />
                } @else {
                    <img
                        class="peer top-0 right-0 absolute bg-white opacity-0 lg:hover:opacity-100 lg:peer-hover:opacity-100 size-full object-cover transition-opacity duration-300 transform"
                        loading="lazy"
                        style="transform: scaleX(-1)"
                        [src]="
                            domHandler.getLargestImageAsWebp(product.images![0])
                        "
                        [srcset]="
                            domHandler.generateSrcsetAsWebp(product.images![0])
                        "
                        alt="product image"
                    />
                }
            } @else {
                <div
                    class="peer top-0 right-0 relative bg-gray-200 size-full"
                ></div>
            }
            <p
                class="bottom-0 relative bg-white p-3 border border-primary w-full text-black text-2xl tracking-tight transition-all lg:group-hover:-translate-y-full transform"
            >
                {{ product.name }}
            </p>
            <div
                class="bottom-0 -z-10 relative flex justify-between bg-white border border-primary w-full text-black text-2xl tracking-tight transition-all -translate-y-[200%] lg:group-hover:-translate-y-full transform"
            >
                <p class="p-3">
                    {{ product.price | customPrice }}
                </p>
                <a
                    routerLink="/{{
                        languageService.getLanguageCode
                    }}/hof/produkt/{{ product.slug }}"
                    class="bg-primary p-3 h-full text-white"
                >
                    {{ "product.toProduct" | translate }}
                </a>
            </div>
        </a>
    }
    @if (!selectedCategory().products.length) {
        <div class="mt-4 text-xl">
            <p>{{ "product.noProductsForCategory" | translate }}</p>
        </div>
    }
</div>
